import { createStyles } from "@mantine/emotion";

export default createStyles ( ( theme, props ) => ( {
	featuredPostContainer: {
		display         : "flex",
		backgroundColor : theme.other.colors.background.tertiary,
		borderRadius    : "10px",
		padding         : "2rem",
		gap             : "2rem",
		flexDirection   : props?.deviceMobileView ? " column-reverse" : "row"
	},
	infoContainer: {
		display       : "flex",
		flexDirection : "column",
		width         : props?.deviceMobileView ? "100%" : "45%",
		gap           : "2rem"
	},
	featuredText: {
		width           : "fit-content",
		backgroundColor : theme.other.paletteNew.tertiaryYellow,
		color           : theme.other.darkMode ? theme.other.paletteNew.secondaryBlack : theme.other.paletteNew.secondaryWhite,
		borderRadius    : "5px",
		padding         : "0 5px"
	},
	heading: {
		fontSize        : "2rem",
		fontWeight      : "500",
		wordBreak       : "break-word",
		textOverflow    : "ellipsis",
		WebkitLineClamp : 2,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical"
	},
	postContent: {
		color           : theme.other.colors.text.secondary,
		wordBreak       : "break-word",
		textOverflow    : "ellipsis",
		WebkitLineClamp : 3,
		overflow        : "hidden",
		display         : "-webkit-box",
		WebkitBoxOrient : "vertical"
	},
	imageContainer: {
		width      : props?.deviceMobileView ? "100%" : "55%",
		display    : "flex",
		alignItems : "center"
	},
	featuredImg: {
		borderRadius: "1rem"
	},
	readingButton: {
		color           : theme.other.paletteNew.primaryDarkBlue,
		backgroundColor : "none",
		border          : `1px solid ${ theme.other.paletteNew.primaryDarkBlue }`,
		borderRadius    : "10px",
		padding         : "0.5rem",
		width           : "fit-content",
		fontSize        : "1.3rem",
		cursor          : "pointer"
	},
	seperator: {
		borderRadius : "50%",
		height       : "3px",
		width        : "3px",
		background   : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		margin       : "0 1rem"
	},
	tagsContainer: {
		display      : "flex",
		alignItems   : "center",
		marginBottom : "1rem"
	},
	dateTag: {
		color    : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		fontSize : "1.2rem"
	},
	nameTag: {
		color    : theme.other.darkMode ? theme.other.paletteNew.darkModeWhite80 : theme.other.paletteNew.secondaryDarkGrey,
		fontSize : "1.2rem"

	}

} ) );
